function featureFlagService (dataBrokerService) {
    return {
        getAsync
    };

    function getAsync (flagName) {
        return dataBrokerService.getItem('featureFlags')
            .then(featureFlags => featureFlags[flagName]);
    }
}

featureFlagService.$inject = [
    'dataBrokerService'
];

export default featureFlagService;
